import styled from 'styled-components';

const Header = styled.header`
    display:flex;
    margin: 13px;
    margin-bottom: 50px;
    flex-direction: row;
    justify-content: space-around;
`;

export default Header;
